import {
  CorporateContactJsonLd,
  DefaultSeo,
  LogoJsonLd,
  OrganizationJsonLd,
  SiteLinksSearchBoxJsonLd,
} from 'next-seo';
import { useRouter } from 'next/router';

import { canonize, toAbsoluteLink } from 'lib/links';

import SEO from '../../../next-seo.config';

import APP from 'constants/app';

const UniversalSchemas = () => {
  const { asPath } = useRouter();

  const url = canonize(asPath);

  return (
    <>
      <DefaultSeo
        {...SEO}
        canonical={url}
        openGraph={{ ...SEO.openGraph, url }}
      />
      <LogoJsonLd
        logo={toAbsoluteLink`${APP.LOCAL_IMAGE_PATH}/features/topbar/promobit-logo.svg`}
        url={APP.URL}
      />
      <OrganizationJsonLd
        address={{
          streetAddress: APP.ADDRESS.STREET,
          addressLocality: APP.ADDRESS.CITY,
          addressRegion: APP.ADDRESS.ACRONYM_STATE,
          postalCode: APP.ADDRESS.POSTAL_CODE,
          addressCountry: APP.ADDRESS.ACRONYM_COUNTRY,
        }}
        contactPoint={{
          contactType: 'customer service',
          email: APP.COMMERCIAL_EMAIL,
          areaServed: 'BR',
          availableLanguage: ['Portuguese'],
        }}
        legalName={APP.LEGAL_NAME}
        logo={toAbsoluteLink(
          `${APP.LOCAL_IMAGE_PATH}/features/topbar/promobit-logo.svg`
        )}
        name={APP.NAME}
        type="organization"
        url={APP.URL}
      />
      <SiteLinksSearchBoxJsonLd
        potentialActions={[
          {
            target: 'https://promobit.com.br/buscar?q={search_term_string}',
            queryInput: 'required name=search_term_string',
          },
        ]}
        url={APP.URL}
      />
      <CorporateContactJsonLd
        contactPoint={[
          {
            contactType: 'customer service',
            email: APP.COMMERCIAL_EMAIL,
            areaServed: 'BR',
            availableLanguage: ['Portuguese'],
          },
        ]}
        logo={toAbsoluteLink(
          `${APP.LOCAL_IMAGE_PATH}/features/topbar/promobit-logo.svg`
        )}
        url={APP.URL}
      />
    </>
  );
};

export default UniversalSchemas;
